import { useEffect, useRef } from "react"

export interface UseInfiniteScrollProps {
  hasMore: boolean
  loadMore: () => unknown
  isLoading: boolean
}

export const useInfiniteScroll = ({
  hasMore,
  loadMore,
  isLoading,
}: UseInfiniteScrollProps) => {
  const pageEndRef = useRef<HTMLDivElement>(null)
  const isLoadingRef = useRef(isLoading)

  // Update the ref whenever isLoading changes
  useEffect(() => {
    isLoadingRef.current = isLoading
  }, [isLoading])

  useEffect(() => {
    if (!hasMore) return

    const observer = new IntersectionObserver((entries) => {
      // Check the ref value instead of the closure value
      if (entries[0].isIntersecting && !isLoadingRef.current) {
        loadMore()
      }
    })

    const currentRef = pageEndRef.current
    if (currentRef) {
      observer.observe(currentRef)
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef)
      }
    }
  }, [hasMore, loadMore])

  return { pageEndRef }
}
